export default __webpack_public_path__ + "fonts/CiscoSansBoldOblique-webfont.eot";